function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.95038 16.6491C1.59153 16.2905 1.01002 16.2904 0.651037 16.6488C0.291568 17.0078 0.291391 17.5903 0.650642 17.9494L6.42383 23.7213L12.197 17.9494C12.5563 17.5903 12.5561 17.0078 12.1966 16.6488C11.8376 16.2904 11.2561 16.2905 10.8973 16.6491L6.42383 21.1194L1.95038 16.6491Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.95038 7.6473C1.59153 8.00589 1.01002 8.006 0.651037 7.64754C0.291568 7.28859 0.291391 6.70612 0.650642 6.34695L6.42383 0.575109L12.197 6.34695C12.5563 6.70612 12.5561 7.28859 12.1966 7.64754C11.8376 8.006 11.2561 8.00589 10.8973 7.6473L6.42383 3.17702L1.95038 7.6473Z",
  fill: "#787878"
});

function SvgSelectDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDropdown);
export default __webpack_public_path__ + "static/media/select-dropdown.53649a3e.svg";
export { ForwardRef as ReactComponent };